import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9bf15808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-cell" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { class: "item-sub" }

import { ref, reactive, computed, onMounted, PropType } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage, ElMessageBox } from 'element-plus'
import CmTable from '@/components/cmTable/index.vue'
import { TableOpt } from '@/components/cmTable/types'
import {
  TableViewMode,
  TableViewModeType,
  TABLE_PREVIEW_PAGE_SIZE,
  TABLE_FULL_PAGE_SIZE_DEFAULT
} from '@/views/dashboard/_enum/table-view-mode'
import { BaseLineService, BaselineCheckItemStatRow } from '@/views/dashboard/safe-status/base-line/base-line.service'
import {
  ensureBaselineRepairItemsLoaded,
  getBaselineCheckItemLabelsById,
  resolveCheckItemNonComplianceCount,
} from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'
import { listCol } from '@/utils/list-columns-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseline-check-item-table',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  /** 为 true 时预览模式下不展示筛选栏右侧按钮（由外层 Card headerRight 承载） */
  suppressToolbarActions: {
    type: Boolean,
    default: false
  }
},
  emits: ["viewAll", "detail", "repairTerminals", "terminalCountClick", "refresh"],
  setup(__props, { expose: __expose, emit: __emit }) {

function formatCheckItemDetectionItem (row: BaselineCheckItemStatRow) {
  void locale.value
  const c = getBaselineCheckItemLabelsById(row.check_item_id)
  return {
    title: c.itemName || row.item_name || row.check_item_id || '--',
    category: c.categoryName || row.category_name || '',
  }
}

const props = __props

const emit = __emit

const injector = useReflectiveInjector([BaseLineService])
const service = injector.get(BaseLineService)
const tableRef = ref<any>(null)
const { refreshList } = useCmTableListRefresh(tableRef)
const { t, locale } = useI18n()

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const form = reactive({
  key_word: '',
  sort: 'substandard_terminal_count',
  asc: false
})
const multipleSelection = ref<BaselineCheckItemStatRow[]>([])

const selectionIds = computed(() => multipleSelection.value.map(r => r.check_item_id))

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    selection: false,
    columns: [
      {
        prop: 'item_display',
        label: t('baselineDashboard.detectionItem'),
        slotName: 'item_display',
        showOverflow: true
      },
      {
        prop: 'non_compliance_count',
        label: t('baselineDashboard.nonCompliantTerminals'),
        sortable: 'custom'
      },
      {
        prop: 'operation',
        label: listCol(t, 'operation'),
        slotName: 'operation',
        width: 150,
        columnOpt: { minWidth: 200, fixed: 'right' }
      }
    ],
    usePagination: false,
    showSearch: false,
    showForm: false,
    showActionBar: false,
    showRightToolbar: true,
    rowKey: 'check_item_id',
    path: 'data',
    totalPath: 'total',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    hiddenPageTool: props.viewMode === TableViewMode.preview,
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined
  }
})

async function getListApi (params: Record<string, unknown>) {
  const isPreview = props.viewMode === TableViewMode.preview
  const page = isPreview ? 1 : (Number(params.page) || 1)
  const limit = isPreview ? TABLE_PREVIEW_PAGE_SIZE : (Number(params.limit) || TABLE_FULL_PAGE_SIZE_DEFAULT)
  try {
    return await service.getCheckItemStatList({
      page,
      limit,
      key_word: String(params.key_word ?? ''),
      sort: (params.sort as string) || 'substandard_terminal_count',
      asc: (params.asc as boolean) ?? false
    })
  } catch {
    return { list: [] as BaselineCheckItemStatRow[], total: 0 }
  }
}

async function handleSearch (value: string) {
  form.key_word = value
  await refreshList()
}

async function handleQuery () {
  await refreshList()
}

function handleReset () {
  form.key_word = ''
  form.sort = 'substandard_terminal_count'
  form.asc = false
  void refreshList()
}

function handleSelectionChange (rows: BaselineCheckItemStatRow[]) {
  multipleSelection.value = rows
}

async function onIgnoreOne (row: BaselineCheckItemStatRow) {
  if (!row.check_item_id) return
  try {
    await ElMessageBox.confirm(
      t('baselineDashboard.confirmIgnoreSingle'),
      t('cmtable.tip'),
      {
        type: 'warning',
        confirmButtonText: t('cmtable.confirm'),
        cancelButtonText: t('common.cancel')
      }
    )
  } catch {
    return
  }
  try {
    await service.batchIgnoreCheckItems({ check_item_ids: [row.check_item_id] })
    ElMessage.success(t('baselineDashboard.batchIgnoreSuccess'))
    void refreshList()
    emit('refresh')
  } catch {
    ElMessage.error(t('baselineDashboard.batchIgnoreFail'))
  }
}

async function onBatchIgnore () {
  if (!selectionIds.value.length) return
  try {
    await ElMessageBox.confirm(
      t('baselineDashboard.confirmBatchIgnore', { count: selectionIds.value.length }),
      t('cmtable.tip'),
      {
        type: 'warning',
        confirmButtonText: t('cmtable.confirm'),
        cancelButtonText: t('common.cancel')
      }
    )
  } catch {
    return
  }
  try {
    await service.batchIgnoreCheckItems({ check_item_ids: selectionIds.value })
    ElMessage.success(t('baselineDashboard.batchIgnoreSuccess'))
    tableRef.value?.tableRef?.clearSelection()
    multipleSelection.value = []
    void refreshList()
    emit('refresh')
  } catch {
    ElMessage.error(t('baselineDashboard.batchIgnoreFail'))
  }
}

const selectedCount = computed(() => selectionIds.value.length)

onMounted(async () => {
  await ensureBaselineRepairItemsLoaded(() => service.getAllBaselineItems())
})

__expose({
  getList: () => void refreshList(),
  batchIgnore: onBatchIgnore,
  selectedCount,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    modelValue: form,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
    "table-opt": tableOpt.value,
    api: getListApi,
    "page-option": pageOption,
    "first-loading": true,
    onChangeSelected: handleSelectionChange
  }, {
    header: _withCtx(() => []),
    item_display: _withCtx(({ row }: any) => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([formatCheckItemDetectionItem(row as BaselineCheckItemStatRow)], (d) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: (row as BaselineCheckItemStatRow).check_item_id
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(d.title), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(d.category), 1)
          ], 64))
        }), 128))
      ])
    ]),
    operation: _withCtx(({ row }: any) => [
      _createVNode(_component_el_button, {
        type: "text",
        size: "small",
        disabled: !_unref(resolveCheckItemNonComplianceCount)(row as BaselineCheckItemStatRow),
        onClick: ($event: any) => (emit('repairTerminals', row as BaselineCheckItemStatRow))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('baselineDashboard.repair')), 1)
        ]),
        _: 2
      }, 1032, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["modelValue", "table-opt"]))
}
}

})